import { atom, useRecoilState, useSetRecoilState } from 'recoil';
import { useCallback } from 'react';
const defaultDrawer = {
  show: false,
  modal: false,
  onClose: null,
  actionButton: null,
  backdropLink: null,
  title: null,
  subHeader: null,
  body: null,
  footer: null,
  placement: 'right',
  width: '72',
  animationDuration: 300,
};

export const drawerState = atom({
  key: 'drawerState',
  default: defaultDrawer,
  effects_UNSTABLE: [
    ({ onSet }) => {
      onSet((newSidebar) => {
        if (typeof window !== 'undefined' && window.zE) {
          if (newSidebar.show && window.zE.hide && window.zE.show) {
            if (typeof window.zE.hide === 'function') window.zE.hide();
          } else if (typeof window.zE.show === 'function') window.zE.show();
        }
      });
    },
  ],
});

export const useDrawer = () => {
  const [value, setDrawer] = useRecoilState(drawerState);

  // useRef to handle setTimeout for close modal to cancel @ open
  const open = useCallback((props = {}) => {
    setDrawer({ ...defaultDrawer, ...props, show: true, modal: true });
  }, []);

  const close = useCallback(() => {
    setDrawer((prev) => ({ ...prev, show: false }));
    setTimeout(() => {
      setDrawer((prev) => ({ ...prev, modal: false }));
    }, value.animationDuration - 10);
  }, [value]);

  return { value, open, close };
};
